import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Injector,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SplitViewHelpModalComponent } from '../../../../../outputs/annotation/annotation-shared/toolbars/static-toolbar/help-modal/split-view-help-modal.component';
import { keyboardShortcutsIcon } from '../../../../../shared/icons/toolbars/keyboard-shortcuts-icon';

@Component({
  selector: 'h3-cv-help-modal-button',
  templateUrl: './cv-help-modal-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CvHelpModalButtonComponent {
  tooltip = 'Keyboard shortcuts';
  keyboardShortcutsIcon = keyboardShortcutsIcon;

  private dialog = inject(MatDialog);

  constructor(private injector: Injector) {}

  openHelpModal() {
    this.dialog.open(SplitViewHelpModalComponent, {
      width: '875px',
      maxWidth: '875px',
      injector: this.injector,
      data: { injector: this.injector },
    });
  }
}
